/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ActionResponseDetail {
  /** @format int32 */
  code?: number | null;
  detail?: string | null;
  source?: ObjectSource;
  title?: string | null;
}

export enum ActorType {
  System = 'system',
  User = 'user',
  Machine = 'machine',
}

export interface AdjustReconciliationRequest {
  adjustment_reason?: string | null;
  confirmed_note_counts?: Record<string, Record<string, number>>;
}

export interface AssetType {
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  name?: string | null;
  record_status?: RecordStatus;
}

/** Request for assigning operator to an existing QA'd ATM */
export interface AssignAtmToOperator {
  /**
   * The Operator's QR lookup code value necessary to assign an ATM to the Operator
   * @minLength 1
   */
  operator_code: string;
}

export interface Atm {
  affiliations?: AtmAffiliation[] | null;
  atm_event_audits?: AtmEventAudit[] | null;
  atm_groups?: AtmGroup[] | null;
  atm_hardware?: AtmHardware;
  atm_integration?: AtmIntegration;
  atm_locations?: AtmLocation[] | null;
  atm_settings?: AtmSetting[] | null;
  box_clears?: BoxClear[] | null;
  cash_clear_id?: string | null;
  /** @format date-time */
  created_at?: string;
  currency?: string | null;
  feature?: AtmFeature;
  heartbeats?: Heartbeat[] | null;
  /** @format int32 */
  id?: number;
  knect_token?: string | null;
  lock_serial_number?: string | null;
  lock_set_to?: string | null;
  machine_id?: string | null;
  modem_serial?: string | null;
  name?: string | null;
  /** @format int32 */
  node_id?: number | null;
  note_dispenser?: NoteDispenser;
  /** @format int32 */
  operator_id?: number | null;
  padlock?: string | null;
  /** @format double */
  previous_thirty_days_uptime_percentage?: number;
  products?: Product[] | null;
  qaid?: boolean;
  queues?: Queue[] | null;
  robot_face_heartbeats?: RobotFaceHeartbeat[] | null;
  sales?: Sale[] | null;
  serial?: string | null;
  /** @format double */
  thirty_days_uptime_percentage?: number;
  token?: string | null;
  /** @format date-time */
  updated_at?: string | null;
}

export interface AtmAffiliation {
  affiliate_id?: string | null;
  atm?: Atm;
  /** @format int32 */
  atm_id?: number;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  record_status?: RecordStatus;
}

export interface AtmEventAudit {
  affiliate_id?: string | null;
  application_id?: string | null;
  atm?: Atm;
  atm_event_kind?: AtmEventKind;
  /** @format int32 */
  atm_id?: number | null;
  correlation_id?: string | null;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  data?: any;
  id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  name?: string | null;
  /** @format int32 */
  operator_id?: number;
  /** @format int32 */
  priority?: number | null;
  record_status?: RecordStatus;
  role_name?: string | null;
}

export enum AtmEventKind {
  CreateCommand = 'create_command',
}

export interface AtmFeature {
  atm?: Atm;
  /** @format int32 */
  atm_id?: number;
  bankline_p_p_c?: boolean;
}

export interface AtmGroup {
  atm?: Atm;
  /** @format int32 */
  atm_id?: number;
  /** @format date-time */
  created_at?: string;
  group?: Group;
  /** @format int32 */
  group_id?: number;
  /** @format int32 */
  id?: number;
  /** @format date-time */
  updated_at?: string | null;
}

export interface AtmHardware {
  atm?: Atm;
  /** @format int32 */
  atm_id?: number;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  manufacturer?: Manufacturer;
  manufacturer_id?: string | null;
  record_status?: RecordStatus;
}

export interface AtmIntegration {
  atm?: Atm;
  /** @format int32 */
  atm_id?: number;
  auth_zero_id?: string | null;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  integration_id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  record_status?: RecordStatus;
  reference_id?: string | null;
  username?: string | null;
}

export interface AtmLocation {
  address2?: string | null;
  active?: boolean;
  address?: string | null;
  atm?: Atm;
  /** @format int32 */
  atm_id?: number;
  city?: string | null;
  country?: string | null;
  /** @format date-time */
  created_at?: string;
  full_address?: string | null;
  /** @format int32 */
  id?: number;
  lat?: string | null;
  local_time_zone?: string | null;
  /** @format int32 */
  location_id?: number | null;
  long?: string | null;
  phone_number?: string | null;
  pick_up_id?: string | null;
  state?: string | null;
  /** @format date-time */
  updated_at?: string | null;
  zipcode?: string | null;
}

export interface AtmOperatorView {
  affiliate_id?: string | null;
  currency?: string | null;
  /** @format int32 */
  id?: number;
  integration?: AtmIntegration;
  lock_serial_number?: string | null;
  lock_set_to?: string | null;
  machine_id?: string | null;
  modem_serial?: string | null;
  name?: string | null;
  padlock?: string | null;
  pick_up_id?: string | null;
  qaid?: string | null;
  serial?: string | null;
  supported_products?: ProductType[] | null;
}

export interface AtmOperatorViewIActionDataResponse {
  correlation_id?: string | null;
  data?: AtmOperatorView;
}

export interface AtmOperatorViewListIActionDataResponse {
  correlation_id?: string | null;
  data?: AtmOperatorView[] | null;
}

export interface AtmSetting {
  atm?: Atm;
  /** @format int32 */
  atm_id?: number;
  /** @format date-time */
  created_at?: string;
  /** @format int32 */
  id?: number;
  setting?: Setting;
  /** @format int32 */
  setting_id?: number;
  /** @format date-time */
  updated_at?: string | null;
}

export interface AtmSettingsViewResponse {
  fees?: FeesViewResponse[] | null;
  /** @format int32 */
  id?: number;
}

export interface AtmSingleViewResponse {
  /** @format int32 */
  atm_id?: number;
  /** @format date-time */
  created_at?: string;
  friendly_name?: string | null;
  integration_id?: string | null;
  integration_reference_id?: string | null;
  /** @format int32 */
  operator_id?: number;
  settings?: AtmSettingsViewResponse;
  supported_products?: ProductType[] | null;
  /** @format date-time */
  updated_at?: string;
  username?: string | null;
}

export interface AtmSingleViewResponseIActionDataResponse {
  correlation_id?: string | null;
  data?: AtmSingleViewResponse;
}

export interface AtmTransferRequest {
  /**
   * Id of the ATM to be transferred.
   * @format int32
   */
  atm_id?: number;
  /**
   * Operator Id of the operator the ATM is being transferred to.
   * @format int32
   */
  destination_operator_id?: number;
  /**
   * Operator Id of the current operator of the ATM.
   * @format int32
   */
  origin_operator_id?: number;
}

export interface AttachmentView {
  content_type?: string | null;
  /** @format date-time */
  created_at?: string;
  file_name?: string | null;
  /** @format int64 */
  file_size_bytes?: number;
  file_url?: string | null;
  id?: string | null;
}

export interface BillNote {
  asset_id?: string | null;
  asset_type?: AssetType;
  asset_type_id?: string | null;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  display_name?: string | null;
  id?: string | null;
  is_active?: boolean;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  metadata?: any;
  record_status?: RecordStatus;
  /** @format int32 */
  unit?: number;
  variant?: string | null;
}

export interface BillNoteView {
  asset_id?: string | null;
  asset_type_id?: string | null;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  display_name?: string | null;
  id?: string | null;
  is_active?: boolean;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  metadata?: any;
  /** @format int32 */
  unit?: number;
  variant?: string | null;
}

export interface BillNoteViewActionResponse {
  correlation_id?: string | null;
  data?: BillNoteView;
  /** @deprecated */
  dictionaries?: any;
  errors?: ActionResponseDetail[] | null;
  included?: any;
  meta?: any;
  warnings?: ActionResponseDetail[] | null;
}

export interface BoundariesCreateParams {
  /**
   * The requested API version
   * @default "2"
   */
  'api-version': string;
}

export interface BoxClear {
  atm?: Atm;
  /** @format int32 */
  atm_id?: number | null;
  audit_logs?: BoxClearAuditLog[] | null;
  /** @format date-time */
  bill_last_recalculated_at?: string | null;
  cash_clear_id?: string | null;
  /** @format date-time */
  created_at?: string;
  currency?: string | null;
  fifty?: string | null;
  five?: string | null;
  has_bills_breakdown?: boolean;
  hundred?: string | null;
  /** @format int32 */
  id?: number;
  /** @format date-time */
  local_created_at?: string;
  local_time_zone?: string | null;
  notes?: BoxClearNote[] | null;
  one?: string | null;
  /** @format int32 */
  operator_id?: number | null;
  provenance?: BoxClearProvenance;
  status?: BoxClearStatus;
  ten?: string | null;
  total_amount_of_bills?: string | null;
  total_worth_of_bills?: string | null;
  twenty?: string | null;
  two?: string | null;
  /** @format date-time */
  updated_at?: string | null;
}

export enum BoxClearAction {
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Confirmed = 'confirmed',
}

export interface BoxClearAuditLog {
  action?: BoxClearAction;
  actor_id?: string | null;
  actor_type?: ActorType;
  /** @format int32 */
  atm_id?: number;
  box_clear?: BoxClear;
  /** @format int32 */
  box_clear_id?: number;
  changes?: any;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  new_state?: any;
  previous_state?: any;
  reason?: string | null;
  record_status?: RecordStatus;
}

export interface BoxClearBoundariesRequest {
  atm_ids?: number[] | null;
  /** @minItems 1 */
  end_dates: string[];
}

export interface BoxClearBoundaryResponse {
  /** @format int32 */
  atm_id?: number;
  box_clear_dates?: string[] | null;
}

export interface BoxClearBoundaryResponseListIActionDataResponse {
  correlation_id?: string | null;
  data?: BoxClearBoundaryResponse[] | null;
}

export interface BoxClearNote {
  author?: string | null;
  body?: string | null;
  box_clear?: BoxClear;
  /** @format int32 */
  box_clear_id?: number;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  /** @format int32 */
  operator_id?: number;
  record_status?: RecordStatus;
}

export interface BoxClearNoteView {
  author?: string | null;
  body?: string | null;
  /** @format int32 */
  box_clear_id?: number;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
}

export enum BoxClearProvenance {
  MachineReported = 'machine_reported',
  HeartbeatInferred = 'heartbeat_inferred',
  Manual = 'manual',
}

export interface BoxClearSimulateCreateRequest {
  /**
   * @format int32
   * @min 0
   * @exclusiveMin true
   */
  atm_id?: number;
  /**
   * @format date-time
   * @minLength 1
   */
  created_at: string;
}

export interface BoxClearSimulateUpdateRequest {
  /**
   * @format date-time
   * @minLength 1
   */
  created_at: string;
}

export enum BoxClearStatus {
  Provisional = 'provisional',
  Confirmed = 'confirmed',
  Invalidated = 'invalidated',
  // DEV-2404: taken from `npm run types` against the testnet swagger, which already publishes these
  // values; the rest of that regeneration was left out to keep unrelated drift out of this PR.
  Deposited = 'deposited',
  DepositedOver = 'deposited_over',
  DepositedUnder = 'deposited_under',
  Voided = 'voided',
}

export interface BulkCreateCaseRequest {
  assigned_user_id?: string | null;
  atm_ids?: number[] | null;
  description?: string | null;
  location_ids?: number[] | null;
  merchant_id?: string | null;
  priority?: CasePriority;
  type?: CaseType;
}

export interface BulkCreateCaseResponse {
  results?: BulkCreateCaseResult[] | null;
}

export interface BulkCreateCaseResponseActionResponse {
  correlation_id?: string | null;
  data?: BulkCreateCaseResponse;
  /** @deprecated */
  dictionaries?: any;
  errors?: ActionResponseDetail[] | null;
  included?: any;
  meta?: any;
  warnings?: ActionResponseDetail[] | null;
}

export interface BulkCreateCaseResult {
  /** @format int32 */
  atm_id?: number | null;
  case_id?: string | null;
  /** @format int32 */
  display_id?: number | null;
  error?: string | null;
  /** @format int32 */
  location_id?: number | null;
  success?: boolean;
}

export interface BulkCreateParams {
  /**
   * The requested API version
   * @default "2"
   */
  'api-version': string;
}

export interface BulkCreateServiceTicketRequest {
  atm_ids?: number[] | null;
  details?: string | null;
  location_ids?: number[] | null;
  ops_service_id?: string | null;
  priority?: ServiceTicketPriority;
  route_id?: string | null;
  service_window?: string | null;
  /** @format date-time */
  start_date?: string | null;
  task_type_ids?: string[] | null;
  /** @format int32 */
  technician_id?: number | null;
}

export interface BulkCreateServiceTicketResponse {
  results?: BulkCreateServiceTicketResult[] | null;
}

export interface BulkCreateServiceTicketResponseActionResponse {
  correlation_id?: string | null;
  data?: BulkCreateServiceTicketResponse;
  /** @deprecated */
  dictionaries?: any;
  errors?: ActionResponseDetail[] | null;
  included?: any;
  meta?: any;
  warnings?: ActionResponseDetail[] | null;
}

export interface BulkCreateServiceTicketResult {
  /** @format int32 */
  atm_id?: number | null;
  /** @format int32 */
  display_id?: number | null;
  error?: string | null;
  /** @format int32 */
  location_id?: number | null;
  service_ticket_id?: string | null;
  success?: boolean;
}

export interface BulkLinkServiceTicketResult {
  error?: string | null;
  service_ticket_id?: string | null;
  success?: boolean;
}

export interface BulkLinkServiceTicketsRequest {
  /** @minItems 1 */
  service_ticket_ids: string[];
}

export interface BulkLinkServiceTicketsResponse {
  results?: BulkLinkServiceTicketResult[] | null;
}

export interface BulkLinkServiceTicketsResponseActionResponse {
  correlation_id?: string | null;
  data?: BulkLinkServiceTicketsResponse;
  /** @deprecated */
  dictionaries?: any;
  errors?: ActionResponseDetail[] | null;
  included?: any;
  meta?: any;
  warnings?: ActionResponseDetail[] | null;
}

export interface BulkUpdateBoxClearRequest {
  /** @minItems 1 */
  box_clear_ids: number[];
  /** @format date-time */
  created_at?: string | null;
  reason?: string | null;
  status?: BoxClearStatus;
}

export enum CaseNoteType {
  Internal = 'internal',
  FieldReport = 'field_report',
  OpsNote = 'ops_note',
}

export enum CasePriority {
  Low = 'low',
  Medium = 'medium',
  High = 'high',
  Critical = 'critical',
}

export interface CaseSingleView {
  assigned_user_id?: string | null;
  /** @format int32 */
  atm_id?: number;
  auto_created?: boolean;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  description?: string | null;
  id?: string | null;
  issue_ids?: string[] | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  /** @format int32 */
  location_id?: number | null;
  merchant_id?: string | null;
  priority?: CasePriority;
  resolution_summary?: string | null;
  /** @format date-time */
  resolved_at?: string | null;
  status?: CaseStatus;
  type?: CaseType;
}

export interface CaseSingleViewActionResponse {
  correlation_id?: string | null;
  data?: CaseSingleView;
  /** @deprecated */
  dictionaries?: any;
  errors?: ActionResponseDetail[] | null;
  included?: any;
  meta?: any;
  warnings?: ActionResponseDetail[] | null;
}

export enum CaseStatus {
  InProgress = 'in_progress',
  Resolved = 'resolved',
  Closed = 'closed',
}

export enum CaseType {
  Machine = 'machine',
  Software = 'software',
  Customer = 'customer',
  Payment = 'payment',
  Merchant = 'merchant',
  Other = 'other',
}

export interface CashBoxCreateParams {
  /**
   * The requested API version
   * @default "2"
   */
  'api-version': string;
}

export interface CashBoxPartialUpdateParams {
  /**
   * The requested API version
   * @default "2"
   */
  'api-version': string;
  /** @format int32 */
  id: number;
}

export interface CashServiceView {
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  description?: string | null;
  id?: string | null;
  is_active?: boolean;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  name?: string | null;
  /** @format int32 */
  operator_id?: number;
}

export interface CashServiceViewActionResponse {
  correlation_id?: string | null;
  data?: CashServiceView;
  /** @deprecated */
  dictionaries?: any;
  errors?: ActionResponseDetail[] | null;
  included?: any;
  meta?: any;
  warnings?: ActionResponseDetail[] | null;
}

export interface CashVaultBranchView {
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  description?: string | null;
  id?: string | null;
  is_active?: boolean;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  name?: string | null;
  /** @format int32 */
  operator_id?: number;
}

export interface CashVaultBranchViewActionResponse {
  correlation_id?: string | null;
  data?: CashVaultBranchView;
  /** @deprecated */
  dictionaries?: any;
  errors?: ActionResponseDetail[] | null;
  included?: any;
  meta?: any;
  warnings?: ActionResponseDetail[] | null;
}

export interface Cassette {
  bill_note?: BillNote;
  bill_note_id?: string | null;
  /** @format int32 */
  capacity?: number | null;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  /** @format int32 */
  current_quantity?: number;
  dispense_logs?: CassetteDispenseLog[] | null;
  /** @format int32 */
  hardware_cassette_slot?: number;
  id?: string | null;
  /** @format date-time */
  last_restocked_at?: string | null;
  last_restocked_by?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  /** @format int32 */
  low_quantity_threshold?: number;
  note_dispenser?: NoteDispenser;
  note_dispenser_id?: string | null;
  /** @format int32 */
  operator_id?: number;
  outlet_status?: CassetteOutletStatus;
  record_status?: RecordStatus;
  status?: CassetteStatus;
}

export interface CassetteDispenseLog {
  bill_note?: BillNote;
  bill_note_id?: string | null;
  cassette?: Cassette;
  cassette_id?: string | null;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  dispense_id?: string | null;
  dispense_info?: any;
  /** @format date-time */
  event_timestamp?: string;
  event_type?: DispenseEventType;
  hardware_response_code?: string | null;
  id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  note_dispenser?: NoteDispenser;
  note_dispenser_id?: string | null;
  /** @format int32 */
  operator_id?: number;
  /** @format int32 */
  quantity_dispensed?: number | null;
  /** @format int32 */
  quantity_rejected?: number | null;
  record_status?: RecordStatus;
  transaction_id?: string | null;
}

export interface CassetteInventoryView {
  bill_note_id?: string | null;
  /** @format int32 */
  hardware_cassette_slot?: number;
  /** @format int32 */
  quantity?: number;
  variant?: string | null;
}

export enum CassetteOutletStatus {
  Unknown = 'unknown',
  Healthy = 'healthy',
  Jammed = 'jammed',
  NotAvailable = 'not_available',
  NotSupported = 'not_supported',
}

export enum CassetteStatus {
  Unknown = 'unknown',
  Full = 'full',
  Low = 'low',
  Missing = 'missing',
  NotAvailable = 'not_available',
  NotSupported = 'not_supported',
}

export interface CassetteUpdate {
  /** @format int32 */
  capacity?: number | null;
  /** @format int32 */
  hardware_cassette_slot?: number;
  /** @format int32 */
  low_quantity_threshold?: number | null;
}

export interface CassetteView {
  bill_note_id?: string | null;
  /** @format int32 */
  capacity?: number | null;
  /** @format int32 */
  current_quantity?: number;
  /** @format int32 */
  hardware_cassette_slot?: number;
  id?: string | null;
  /** @format date-time */
  last_restocked_at?: string | null;
  last_restocked_by?: string | null;
  /** @format int32 */
  low_quantity_threshold?: number;
  outlet_status?: CassetteOutletStatus;
  status?: CassetteStatus;
}

export interface CompleteDispenseRequest {
  /**
   * 9 numbers with “,” delimiter which look like “10,10,10,0,0,0,0,0,0” The numbers mean as follow in order:
   * 1st - The number of notes passed the cassette entry,
   * 2nd - The number of notes requested for dispensing,
   * 3rd - The number of dispensed notes,
   * 4th - The number of rejected notes because of skew,
   * 5th - The number of rejected notes because of abnormal space,
   * 6th – The number of rejected notes because of long length,
   * 7th - The number of rejected notes because of short length,
   * 8th - The number of rejected notes because of double note,
   * 9th – The total number of rejected notes
   */
  dispensed_info1?: string | null;
  dispensed_info2?: string | null;
  dispensed_info3?: string | null;
  dispensed_info4?: string | null;
  /**
   * Unity's Dispense.id for this physical dispense. A report repeated with the same id is
   * applied once; one with the same id and different counts is refused with a 409.
   */
  dispense_id?: string | null;
  /**
   * Indicates the dispensed note count of each cassette and looks like “5,5,0,0”.
   * each column represents each cassette.
   */
  dispensed_count?: string | null;
  is_test_dispense?: boolean;
  transaction_id?: string | null;
}

export interface ConfirmBoxClearRequest {
  reason?: string | null;
}

export interface ConfirmPartialUpdateParams {
  /**
   * The requested API version
   * @default "2"
   */
  'api-version': string;
  /** @format int32 */
  id: number;
}

export interface CreateBillNoteRequest {
  /** @minLength 1 */
  asset_id: string;
  /** @minLength 1 */
  asset_type_id: string;
  /** @minLength 1 */
  display_name: string;
  metadata?: Record<string, any>;
  /**
   * @format int32
   * @min 0
   * @exclusiveMin true
   */
  unit?: number;
  variant?: string | null;
}

export interface CreateBoxClearNoteRequest {
  /** @minLength 1 */
  author: string;
  /**
   * @minLength 1
   * @maxLength 10000
   */
  note_text: string;
}

export interface CreateBoxClearRequest {
  /** @format int32 */
  atm_id?: number;
  /** @format date-time */
  created_at?: string;
  reason?: string | null;
}

export interface CreateCaseNoteRequest {
  author?: string | null;
  note_text?: string | null;
  note_type?: CaseNoteType;
}

export interface CreateCaseRequest {
  assigned_user_id?: string | null;
  /** @format int32 */
  atm_id?: number;
  description?: string | null;
  issue_ids?: string[] | null;
  merchant_id?: string | null;
  priority?: CasePriority;
  type?: CaseType;
}

export interface CreateCashServiceRequest {
  description?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
}

export interface CreateCashVaultBranchRequest {
  description?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
}

export interface CreateIssueRequest {
  /**
   * @format int32
   * @min 0
   * @exclusiveMin true
   */
  atm_id?: number;
  /**
   * @minLength 1
   * @maxLength 200
   */
  issue_type: string;
  linked_service_ticket_id?: string | null;
  severity?: IssueSeverity;
}

export interface CreateMachineEventRequest {
  details?: any;
  event_type?: MachineEventType;
}

export interface CreateOpsServiceRequest {
  description?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
}

export interface CreateRestockRequest {
  /** @format int32 */
  atm_id?: number;
  cassettes?: CreateRestockRequestItem[] | null;
  decommissioned_cassettes?: DecommissionCassetteRequestItem[] | null;
  loaded_bag_id?: string | null;
  notes?: string | null;
  restock_type?: RestockRequestType;
}

export interface CreateRestockRequestItem {
  bill_note_id?: string | null;
  /** @format int32 */
  cassette_index?: number;
  /** @format int32 */
  notes_count?: number;
}

export interface CreateRouteRequest {
  name?: string | null;
  notes?: string | null;
  /** @format date-time */
  scheduled_at?: string | null;
  /** @format int32 */
  technician_id?: number | null;
}

export interface CreateServiceTicketNoteRequest {
  author?: string | null;
  note_text?: string | null;
  note_type?: ServiceTicketNoteType;
}

export interface CreateServiceTicketRequest {
  case_id?: string | null;
  details?: string | null;
  /** @format int32 */
  location_id?: number | null;
  ops_service_id?: string | null;
  priority?: ServiceTicketPriority;
  route_id?: string | null;
  service_window?: string | null;
  /** @format date-time */
  start_date?: string | null;
  task_type_ids?: string[] | null;
  /** @format int32 */
  technician_id?: number | null;
}

export interface CreateServiceTicketTaskRequest {
  description?: string | null;
  task_type_id?: string | null;
}

export interface CreateTaskResolutionReasonRequest {
  description?: string | null;
  is_success_reason?: boolean;
  name?: string | null;
}

export interface CreateTaskTypeRequest {
  description?: string | null;
  name?: string | null;
}

export interface DecommissionCassetteRequestItem {
  /** @format int32 */
  cassette_index?: number;
}

export enum DeviceStatus {
  Online = 'online',
  Offline = 'offline',
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
}

export enum DispenseEventType {
  DispenseInitiated = 'dispense_initiated',
  DispenseCompleted = 'dispense_completed',
  DispenseFailed = 'dispense_failed',
  RejectDetected = 'reject_detected',
  TestDispense = 'test_dispense',
}

export interface FailDispenseRequest {
  /**
   * 9 numbers with “,” delimiter which look like “10,10,10,0,0,0,0,0,0” The numbers mean as follow in order:
   * 1st - The number of notes passed the cassette entry,
   * 2nd - The number of notes requested for dispensing,
   * 3rd - The number of dispensed notes,
   * 4th - The number of rejected notes because of skew,
   * 5th - The number of rejected notes because of abnormal space,
   * 6th – The number of rejected notes because of long length,
   * 7th - The number of rejected notes because of short length,
   * 8th - The number of rejected notes because of double note,
   * 9th – The total number of rejected notes
   */
  dispensed_info1?: string | null;
  dispensed_info2?: string | null;
  dispensed_info3?: string | null;
  dispensed_info4?: string | null;
  /**
   * Unity's Dispense.id for this physical dispense. A report repeated with the same id is
   * applied once; one with the same id and different counts is refused with a 409.
   */
  dispense_id?: string | null;
  /**
   * Indicates the dispensed note count of each cassette and looks like “5,5,0,0”.
   * each column represents each cassette.
   */
  dispensed_count?: string | null;
  is_test_dispense?: boolean;
  /**
   * 0 - No Error
   * -1 Fail to commit a command
   * -2 Device timed out.
   * -3 Device is processing other command.
   * -5 Communication Line is down.
   * -6 Other error occurs
   * -7 The function is not supported
   * -8 Unknown error occurs
   * -10 The device port is already opened.
   * -11 The requested amount cannot be dispensed because the Cash Dispenser cannot mix the amount with its denominations.
   * -12 The denomination is invalid.
   * -13 The current bill count is too small to be dispensed.
   * -14 The country code is invalid.
   * -15 Cassette Count is too small or too big. (It should be 1 ~ 4)
   * -16 parameter values are invalid
   * -17 Can’t find and open the commnuciation port for CDU
   * -18 The License Key is not correct, so CDU device can’t be opened.
   * -20 CDU Security Key is not syncronized
   * -21 CDU DIP Switch is set to incorrect position
   * -22 The cassette is empty
   * @format int32
   */
  reason?: number;
  transaction_id?: string | null;
}

export interface Fee {
  /** @format float */
  flat?: number;
  /** @format int32 */
  max?: number;
  /** @format int32 */
  min?: number;
  /** @format float */
  percent?: number;
  precio_host?: string | null;
}

export interface FeesViewResponse {
  /** @format float */
  flat?: number;
  /** @format int32 */
  max?: number;
  /** @format int32 */
  min?: number;
  /** @format float */
  percent?: number;
  precio_host?: string | null;
}

export enum FilterOperator {
  None = 'none',
  Equal = 'equal',
  NotEqual = 'not_equal',
  GreaterThan = 'greater_than',
  GreaterThanOrEqual = 'greater_than_or_equal',
  LessThan = 'less_than',
  LessThanOrEqual = 'less_than_or_equal',
  Contains = 'contains',
  NotContains = 'not_contains',
  StartsWith = 'starts_with',
  EndsWith = 'ends_with',
  And = 'and',
  Or = 'or',
}

export interface GetAtmSettingResponse {
  bitstop_fee?: string | null;
  country_code?: string | null;
  currency?: string | null;
  fees?: FeesViewResponse[] | null;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  kyc?: number;
  lang?: string | null;
  min_bill?: string | null;
  setting_name?: string | null;
  supported_countries?: SettingSupportedCountry[] | null;
  supported_languages?: SettingSupportedLanguage[] | null;
  time_zone?: string | null;
}

export interface GetAtmSettingResponseIActionDataResponse {
  correlation_id?: string | null;
  data?: GetAtmSettingResponse;
}

export interface Group {
  atm_groups?: AtmGroup[] | null;
  /** @format date-time */
  created_at?: string;
  group_name?: string | null;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  operator_id?: number;
  setting?: Setting;
  /** @format int32 */
  setting_id?: number | null;
  /** @format date-time */
  updated_at?: string | null;
}

export interface Heartbeat {
  atm?: Atm;
  /** @format int32 */
  atm_id?: number | null;
  /** @format int32 */
  barcode_scanner_status?: number | null;
  /** @format int32 */
  bill_acceptor_status?: number | null;
  /** @format int32 */
  bill_dispenser_status?: number | null;
  /** @format int32 */
  card_reader_status?: number | null;
  /** @format double */
  cpu_usage?: number | null;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  /** @format int32 */
  fifty?: number | null;
  /** @format int32 */
  five?: number | null;
  hdd_capacity?: string | null;
  /** @format int32 */
  hundred?: number | null;
  id?: string | null;
  /** @format int32 */
  imaging_device_status?: number | null;
  in_transaction?: boolean | null;
  ip_addresses?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  /** @format int32 */
  machine_status?: number | null;
  machine_version?: string | null;
  /** @format double */
  memory_usage?: number | null;
  /** @format double */
  memory_usage_percentage?: number | null;
  miniverse_version?: string | null;
  /** @format int32 */
  one?: number | null;
  /** @format int32 */
  phidget_board_status?: number | null;
  /** @format int32 */
  printer_status?: number | null;
  record_status?: RecordStatus;
  robot_face_version?: string | null;
  /** @format int32 */
  ten?: number | null;
  /** @format int32 */
  total_amount_of_bills?: number | null;
  /** @format int32 */
  total_worth_of_bills?: number | null;
  /** @format int32 */
  twenty?: number | null;
  /** @format int32 */
  two?: number | null;
  up_time?: string | null;
  /** @format int32 */
  uptime_days?: number;
}

export interface IActionErrorResponse {
  correlation_id?: string | null;
  errors?: ActionResponseDetail[] | null;
}

export interface InvalidateBoxClearRequest {
  reason?: string | null;
}

export interface InvalidatePartialUpdateParams {
  /**
   * The requested API version
   * @default "2"
   */
  'api-version': string;
  /** @format int32 */
  id: number;
}

export interface InventoryView {
  cassettes?: CassetteInventoryView[] | null;
}

export interface InventoryViewIActionDataResponse {
  correlation_id?: string | null;
  data?: InventoryView;
}

export enum IssueSeverity {
  Low = 'low',
  Medium = 'medium',
  High = 'high',
  Critical = 'critical',
}

export interface IssueSingleView {
  /** @format int32 */
  atm_id?: number;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  /** @format date-time */
  detected_at?: string;
  id?: string | null;
  issue_type?: string | null;
  linked_case_id?: string | null;
  linked_service_ticket_id?: string | null;
  /** @format int32 */
  location_id?: number | null;
  severity?: IssueSeverity;
  status?: IssueStatus;
}

export interface IssueSingleViewActionResponse {
  correlation_id?: string | null;
  data?: IssueSingleView;
  /** @deprecated */
  dictionaries?: any;
  errors?: ActionResponseDetail[] | null;
  included?: any;
  meta?: any;
  warnings?: ActionResponseDetail[] | null;
}

export enum IssueStatus {
  Active = 'active',
  Resolved = 'resolved',
}

/**
 * It is expected that a ResidualBagId is provided for each cassette and for the reject bin.
 * But the SAME bag ID CAN be reused if the same physical bag is used for multiple cassettes or the reject bin.
 */
export interface LoadRestockRequest {
  access_code?: string | null;
  cassette_residual_bags?: Record<string, string>;
  loaded_bag_id?: string | null;
  reject_bin_residual_bag_id?: string | null;
}

export enum MachineEventType {
  HardwareFailure = 'hardware_failure',
  HardwareRecovered = 'hardware_recovered',
  MiddlemanOffline = 'middleman_offline',
  MiddlemanRecovered = 'middleman_recovered',
  ClientOffline = 'client_offline',
  ClientRecovered = 'client_recovered',
  CashboxRemoved = 'cashbox_removed',
  CashboxInserted = 'cashbox_inserted',
  ClockDriftDetected = 'clock_drift_detected',
  ClockDriftResolved = 'clock_drift_resolved',
  SafeDoorOpened = 'safe_door_opened',
  SafeDoorClosed = 'safe_door_closed',
  CashReduction = 'cash_reduction',
  CashClear = 'cash_clear',
  PsuPowerDisconnected = 'psu_power_disconnected',
  PsuPowerRestored = 'psu_power_restored',
  CduConfigurationMismatch = 'cdu_configuration_mismatch',
  CduConfigurationMismatchResolved = 'cdu_configuration_mismatch_resolved',
  CduCassettePullWithoutOpenRestock = 'cdu_cassette_pull_without_open_restock',
  CduCassettePullWithOpenRestock = 'cdu_cassette_pull_with_open_restock',
  CduCassetteInserted = 'cdu_cassette_inserted',
}

export interface MachineRestockRequestItemView {
  bill_note_id?: string | null;
  cassette_id?: string | null;
  /** @format int32 */
  cassette_index?: number;
  currency_code?: string | null;
  /** @format double */
  denomination_value?: number;
  id?: string | null;
  /** @format int32 */
  notes_count?: number;
}

export interface MachineRestockRequestView {
  access_code?: string | null;
  /** @format int32 */
  atm_id?: number;
  /** @format date-time */
  created_at?: string;
  id?: string | null;
  is_first_request?: boolean;
  items?: MachineRestockRequestItemView[] | null;
  /** @format date-time */
  last_updated_at?: string;
  loaded_bag_id?: string | null;
  status?: RestockRequestStatus;
  type?: RestockRequestType;
}

export interface MachineRestockRequestViewIActionDataResponse {
  correlation_id?: string | null;
  data?: MachineRestockRequestView;
}

export interface Manufacturer {
  atm_hardware?: AtmHardware[] | null;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  record_status?: RecordStatus;
}

export interface NoteDispenser {
  atm?: Atm;
  /** @format int32 */
  atm_id?: number;
  /** @format int32 */
  cassette_count?: number;
  cassettes?: Cassette[] | null;
  cdu_license_key?: string | null;
  cdu_type?: string | null;
  country_code?: string | null;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  device_status?: DeviceStatus;
  id?: string | null;
  /** @format date-time */
  initialized_at?: string | null;
  last_completed_restock_request?: RestockRequest;
  last_completed_restock_request_id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  manufacturer?: string | null;
  /** @format int32 */
  operator_id?: number;
  record_status?: RecordStatus;
  status_detail?: string | null;
  version?: string | null;
}

export interface NoteDispenserConfigView {
  /** @format int32 */
  cassette_count?: number;
  cdu_license_key?: string | null;
}

export interface NoteDispenserConfigViewIActionDataResponse {
  correlation_id?: string | null;
  data?: NoteDispenserConfigView;
}

export interface NoteDispenserView {
  /** @format int32 */
  cassette_count?: number;
  cassettes?: CassetteView[] | null;
  cdu_license_key?: string | null;
  cdu_type?: string | null;
  country_code?: string | null;
  device_status?: DeviceStatus;
  id?: string | null;
  /** @format date-time */
  initialized_at?: string | null;
  manufacturer?: string | null;
  status_detail?: string | null;
}

export interface NoteDispenserViewIActionDataResponse {
  correlation_id?: string | null;
  data?: NoteDispenserView;
}

export interface NotesCreateParams {
  /**
   * The requested API version
   * @default "2"
   */
  'api-version': string;
  /** @format int32 */
  id: number;
}

export interface ObjectActionResponse {
  correlation_id?: string | null;
  data?: any;
  /** @deprecated */
  dictionaries?: any;
  errors?: ActionResponseDetail[] | null;
  included?: any;
  meta?: any;
  warnings?: ActionResponseDetail[] | null;
}

export interface ObjectSource {
  example?: string | null;
  parameter?: string | null;
  pointer?: string | null;
}

export interface OpsServiceView {
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  description?: string | null;
  id?: string | null;
  is_active?: boolean;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  name?: string | null;
  /** @format int32 */
  operator_id?: number;
}

export interface OpsServiceViewActionResponse {
  correlation_id?: string | null;
  data?: OpsServiceView;
  /** @deprecated */
  dictionaries?: any;
  errors?: ActionResponseDetail[] | null;
  included?: any;
  meta?: any;
  warnings?: ActionResponseDetail[] | null;
}

export interface PaginationMetadata {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
  /** @format int32 */
  total_items?: number;
  /** @format int32 */
  total_pages?: number;
}

export interface Product {
  atms?: Atm[] | null;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  name?: string | null;
  product_type?: ProductType;
  record_status?: RecordStatus;
}

export enum ProductType {
  BuyCryptoCash = 'buy_crypto_cash',
  SellCryptoCash = 'sell_crypto_cash',
  BuyCryptoDebit = 'buy_crypto_debit',
  SellCryptoDebit = 'sell_crypto_debit',
}

export interface ProductTypeArrayIActionDataResponse {
  correlation_id?: string | null;
  data?: ProductType[] | null;
}

export interface Queue {
  args?: string | null;
  atm?: Atm;
  /** @format int32 */
  atm_id?: number | null;
  command?: string | null;
  /** @format date-time */
  created_at?: string;
  delivered?: boolean;
  /** @format int32 */
  id?: number;
  /** @format date-time */
  updated_at?: string | null;
}

export interface ReconciliationRequest {
  /**
   * The structure is: bagid -> denomination -> count
   * Example:
   * [
   *     "1a986fe9-ad04-4408-a0a2-b144eea345eb": { // Residual Bag ID
   *         "note-id-of-$20": 5, // 5 notes of denomination 20
   *         "note-id-of-$50": 2  // 2 notes of denomination 50,
   *     },
   *     "3b5c6d7e-8f90-1234-5678-9abcdef01234": { ... // Another Residual Bag ID }
   * ]
   */
  confirmed_note_counts?: Record<string, Record<string, number>>;
  note?: string | null;
}

export enum RecordStatus {
  Active = 'active',
  Inactive = 'inactive',
  Retired = 'retired',
  Deleted = 'deleted',
}

/** The client HTTP model representing an AtmIntegration resource */
export interface RegisterAtmIntegrationRequest {
  /**
   * The client friendly name.
   * @minLength 1
   */
  friendly_name: string;
  /** The array of products to associate with a freshly created ATM. */
  products?: ProductType[] | null;
}

export interface ResidualBag {
  /** @format int32 */
  atm_id?: number;
  bag_type?: ResidualBagType;
  /** @format date-time */
  bank_confirmed_at?: string | null;
  /** @format date-time */
  collected_at?: string;
  collected_by?: string | null;
  contents?: ResidualBagContent[] | null;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  id?: string | null;
  is_confirmed?: boolean;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  /** @format int32 */
  operator_id?: number;
  record_status?: RecordStatus;
  residual_bag_id?: string | null;
  restock_request?: RestockRequest;
  restock_request_id?: string | null;
  /** @format int32 */
  total_note_count?: number;
}

export interface ResidualBagContent {
  bill_note?: BillNote;
  bill_note_id?: string | null;
  /** @format int32 */
  confirmed_note_count?: number | null;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  /** @format int32 */
  estimated_note_count?: number;
  id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  /** @format int32 */
  operator_id?: number;
  record_status?: RecordStatus;
  residual_bag?: ResidualBag;
  residual_bag_id?: string | null;
}

export enum ResidualBagType {
  RejectBinOnly = 'reject_bin_only',
  CassetteOnly = 'cassette_only',
  RejectBinAndCassette = 'reject_bin_and_cassette',
}

export interface ResolveServiceTicketTaskRequest {
  resolution?: TaskResolution;
  resolution_notes?: string | null;
  resolution_reason_id?: string | null;
}

export interface RestockRequest {
  access_code?: string | null;
  adjustments?: RestockRequestAdjustment[] | null;
  atm?: Atm;
  /** @format int32 */
  atm_id?: number;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  id?: string | null;
  items?: RestockRequestItem[] | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  /** @format date-time */
  loaded_at?: string | null;
  loaded_bag_id?: string | null;
  next_loaded_full_restock_request?: RestockRequest;
  next_loaded_full_restock_request_id?: string | null;
  notes?: string | null;
  /** @format int32 */
  operator_id?: number;
  /** @format date-time */
  reconciled_at?: string | null;
  record_status?: RecordStatus;
  residual_bags?: ResidualBag[] | null;
  state_changes?: RestockRequestStateChange[] | null;
  status?: RestockRequestStatus;
}

export interface RestockRequestAdjustment {
  adjusted_restock_items?: any;
  adjustment_reason?: string | null;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  /** @format int32 */
  operator_id?: number;
  previous_restock_items?: any;
  record_status?: RecordStatus;
  restock_request?: RestockRequest;
  restock_request_id?: string | null;
}

export enum RestockRequestChangeType {
  Created = 'created',
  Fulfilled = 'fulfilled',
  Reconciled = 'reconciled',
  Completed = 'completed',
  Updated = 'updated',
  Cancelled = 'cancelled',
  Loaded = 'loaded',
  CollectedResiduals = 'collected_residuals',
}

export interface RestockRequestItem {
  bill_note?: BillNote;
  bill_note_id?: string | null;
  cassette?: Cassette;
  cassette_id?: string | null;
  /** @format int32 */
  cassette_index?: number;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  /** @format int32 */
  notes_count?: number;
  /** @format int32 */
  operator_id?: number;
  record_status?: RecordStatus;
  restock_request?: RestockRequest;
  restock_request_id?: string | null;
  type?: RestockRequestItemType;
}

export enum RestockRequestItemType {
  RestockCassette = 'restock_cassette',
  DecommissionCassette = 'decommission_cassette',
  AddNotes = 'add_notes',
}

export interface RestockRequestItemView {
  bill_note_id?: string | null;
  cassette_id?: string | null;
  /** @format int32 */
  cassette_index?: number;
  id?: string | null;
  /** @format int32 */
  notes_count?: number;
}

export interface RestockRequestStateChange {
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  /** @format int32 */
  operator_id?: number;
  record_status?: RecordStatus;
  restock_request?: RestockRequest;
  restock_request_id?: string | null;
  /** @format int32 */
  sequence_number?: number;
  snapshot?: any;
  type?: RestockRequestChangeType;
}

export enum RestockRequestStatus {
  Created = 'created',
  Fulfilled = 'fulfilled',
  Loaded = 'loaded',
  PendingReconcile = 'pending_reconcile',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

export enum RestockRequestType {
  Add = 'add',
  Swap = 'swap',
}

export interface RestockRequestView {
  access_code?: string | null;
  /** @format int32 */
  atm_id?: number;
  /** @format date-time */
  created_at?: string;
  id?: string | null;
  items?: RestockRequestItemView[] | null;
  /** @format date-time */
  last_updated_at?: string;
  loaded_bag_id?: string | null;
  notes?: string | null;
  status?: RestockRequestStatus;
}

export interface RestockRequestViewFilter {
  operands?: RestockRequestViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface RestockRequestViewIActionDataResponse {
  correlation_id?: string | null;
  data?: RestockRequestView;
}

export interface RestockRequestViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: RestockRequestView[] | null;
  meta?: RestockRequestViewPaginatableResponseMetadata;
}

export interface RestockRequestViewPaginatableRequest {
  filter?: RestockRequestViewFilter;
  pagination?: RestockRequestViewPagination;
  search_text?: string | null;
}

export interface RestockRequestViewPaginatableResponseMetadata {
  filter?: RestockRequestViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface RestockRequestViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface RobotFaceHeartbeat {
  app_version?: string | null;
  atm?: Atm;
  /** @format int32 */
  atm_id?: number | null;
  /** @format date-time */
  created_at?: string;
  fees?: Fee[] | null;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  machine_status?: number;
  /** @format int32 */
  setting_id?: number;
  /** @format date-time */
  updated_at?: string | null;
}

export interface RobotfaceQueue {
  args?: string | null;
  atm?: Atm;
  /** @format int32 */
  atm_id?: number | null;
  command?: string | null;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  delivered?: boolean;
  id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  record_status?: RecordStatus;
}

export interface RobotfaceQueueIActionDataResponse {
  correlation_id?: string | null;
  data?: RobotfaceQueue;
}

export interface RouteServiceTicketView {
  /** @format date-time */
  created_at?: string;
  id?: string | null;
  service_ticket_id?: string | null;
}

export interface RouteSingleView {
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  name?: string | null;
  notes?: string | null;
  route_status?: RouteStatus;
  /** @format date-time */
  scheduled_at?: string | null;
  /** @format int32 */
  technician_id?: number | null;
}

export interface RouteSingleViewActionResponse {
  correlation_id?: string | null;
  data?: RouteSingleView;
  /** @deprecated */
  dictionaries?: any;
  errors?: ActionResponseDetail[] | null;
  included?: any;
  meta?: any;
  warnings?: ActionResponseDetail[] | null;
}

export enum RouteStatus {
  Planning = 'planning',
  Scheduled = 'scheduled',
  InProgress = 'in_progress',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

export interface Sale {
  atm?: Atm;
  /** @format int32 */
  atm_id?: number | null;
  btc?: string | null;
  /** @format date-time */
  created_at?: string;
  /** @format int32 */
  customer_id?: number;
  /** @format int32 */
  id?: number;
  idtx?: string | null;
  /** @format date-time */
  updated_at?: string;
}

export enum ServiceTicketNoteType {
  Ops = 'ops',
  Field = 'field',
  Internal = 'internal',
}

export interface ServiceTicketNoteView {
  attachments?: AttachmentView[] | null;
  author?: string | null;
  body?: string | null;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  service_ticket_id?: string | null;
  type?: ServiceTicketNoteType;
}

export interface ServiceTicketNoteViewActionResponse {
  correlation_id?: string | null;
  data?: ServiceTicketNoteView;
  /** @deprecated */
  dictionaries?: any;
  errors?: ActionResponseDetail[] | null;
  included?: any;
  meta?: any;
  warnings?: ActionResponseDetail[] | null;
}

export enum ServiceTicketPriority {
  Low = 'low',
  Medium = 'medium',
  High = 'high',
  Critical = 'critical',
}

export interface ServiceTicketSingleView {
  auto_created?: boolean;
  case_id?: string | null;
  /** @format date-time */
  completed_at?: string | null;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  details?: string | null;
  /** @format date-time */
  finish_date?: string | null;
  id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  ops_service_id?: string | null;
  service_ticket_links?: RouteServiceTicketView[] | null;
  /** @format date-time */
  start_date?: string | null;
  status?: ServiceTicketStatus;
  tasks?: ServiceTicketTaskView[] | null;
  /** @format int32 */
  technician_id?: number | null;
}

export interface ServiceTicketSingleViewActionResponse {
  correlation_id?: string | null;
  data?: ServiceTicketSingleView;
  /** @deprecated */
  dictionaries?: any;
  errors?: ActionResponseDetail[] | null;
  included?: any;
  meta?: any;
  warnings?: ActionResponseDetail[] | null;
}

export enum ServiceTicketStatus {
  Planned = 'planned',
  InProgress = 'in_progress',
  Completed = 'completed',
  Failed = 'failed',
  Cancelled = 'cancelled',
}

export interface ServiceTicketTaskView {
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  description?: string | null;
  id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  resolution?: TaskResolution;
  resolution_notes?: string | null;
  resolution_reason_id?: string | null;
  resolution_reason_name?: string | null;
  /** @format date-time */
  resolved_at?: string | null;
  resolved_by?: string | null;
  service_ticket_id?: string | null;
  /** @format int32 */
  sort_order?: number;
  task_type_id?: string | null;
  task_type_name?: string | null;
}

export interface ServiceTicketTaskViewActionResponse {
  correlation_id?: string | null;
  data?: ServiceTicketTaskView;
  /** @deprecated */
  dictionaries?: any;
  errors?: ActionResponseDetail[] | null;
  included?: any;
  meta?: any;
  warnings?: ActionResponseDetail[] | null;
}

export interface SetAtmSerialRequest {
  /** @minLength 1 */
  serial_number: string;
}

export interface Setting {
  atm_settings?: AtmSetting[] | null;
  bitstop_fee?: string | null;
  country_code?: string | null;
  /** @format date-time */
  created_at?: string;
  currency?: string | null;
  default_setting?: boolean;
  fees?: string | null;
  groups?: Group[] | null;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  kyc?: number;
  lang?: string | null;
  min_bill?: string | null;
  /** @format int32 */
  operator_id?: number;
  setting_name?: string | null;
  setting_supported_countries?: SettingSupportedCountry[] | null;
  setting_supported_languages?: SettingSupportedLanguage[] | null;
  time_zone?: string | null;
  /** @format date-time */
  updated_at?: string | null;
}

export interface SettingSupportedCountry {
  country?: SupportedCountry;
  /** @format int32 */
  country_id?: number;
  /** @format date-time */
  created_at?: string;
  /** @format int32 */
  id?: number;
  setting?: Setting;
  /** @format int32 */
  setting_id?: number;
  /** @format date-time */
  updated_at?: string | null;
}

export interface SettingSupportedLanguage {
  /** @format date-time */
  created_at?: string;
  /** @format int32 */
  id?: number;
  language?: SupportedLanguage;
  /** @format int32 */
  language_id?: number;
  setting?: Setting;
  /** @format int32 */
  setting_id?: number;
  /** @format date-time */
  updated_at?: string | null;
}

export interface SimulateCreateParams {
  /**
   * The requested API version
   * @default "2"
   */
  'api-version': string;
}

export interface SimulateDeleteParams {
  /**
   * The requested API version
   * @default "2"
   */
  'api-version': string;
  /** @format int32 */
  id: number;
}

export interface SimulateUpdateParams {
  /**
   * The requested API version
   * @default "2"
   */
  'api-version': string;
  /** @format int32 */
  id: number;
}

export interface SupportedCountry {
  country?: string | null;
  country_code?: string | null;
  /** @format date-time */
  created_at?: string;
  /** @format int32 */
  id?: number;
  setting_supported_countries?: SettingSupportedCountry[] | null;
  /** @format date-time */
  updated_at?: string | null;
}

export interface SupportedLanguage {
  /** @format date-time */
  created_at?: string;
  /** @format int32 */
  id?: number;
  lang?: string | null;
  locale?: string | null;
  setting_supported_languages?: SettingSupportedLanguage[] | null;
  /** @format date-time */
  updated_at?: string | null;
}

export enum TaskResolution {
  Pending = 'pending',
  Success = 'success',
  Failure = 'failure',
}

export interface TaskResolutionReasonView {
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  description?: string | null;
  id?: string | null;
  is_active?: boolean;
  is_success_reason?: boolean;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  name?: string | null;
  /** @format int32 */
  operator_id?: number;
}

export interface TaskResolutionReasonViewActionResponse {
  correlation_id?: string | null;
  data?: TaskResolutionReasonView;
  /** @deprecated */
  dictionaries?: any;
  errors?: ActionResponseDetail[] | null;
  included?: any;
  meta?: any;
  warnings?: ActionResponseDetail[] | null;
}

export interface TaskTypeView {
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  description?: string | null;
  id?: string | null;
  is_active?: boolean;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  name?: string | null;
  /** @format int32 */
  operator_id?: number;
}

export interface TaskTypeViewActionResponse {
  correlation_id?: string | null;
  data?: TaskTypeView;
  /** @deprecated */
  dictionaries?: any;
  errors?: ActionResponseDetail[] | null;
  included?: any;
  meta?: any;
  warnings?: ActionResponseDetail[] | null;
}

export interface TransactionDispenseLogView {
  bill_note_id?: string | null;
  cassette_id?: string | null;
  /** @format date-time */
  created_at?: string;
  dispense_info?: any;
  /** @format date-time */
  event_timestamp?: string;
  event_type?: DispenseEventType;
  hardware_response_code?: string | null;
  id?: string | null;
  note_dispenser_id?: string | null;
  /** @format int32 */
  quantity_dispensed?: number | null;
  /** @format int32 */
  quantity_rejected?: number | null;
  transaction_id?: string | null;
}

export interface TransactionDispenseLogViewListIActionDataResponse {
  correlation_id?: string | null;
  data?: TransactionDispenseLogView[] | null;
}

export interface UnityBoxClearSimulationItem {
  /** @format int32 */
  box_clear_id?: number | null;
  cash_clear_id?: string | null;
  /** @format date-time */
  created_at?: string | null;
  original_values?: UnityBoxClearSimulationValues;
  simulated_values?: UnityBoxClearSimulationValues;
}

export interface UnityBoxClearSimulationValues {
  /** @format int32 */
  fifty?: number | null;
  /** @format int32 */
  five?: number | null;
  has_bills_breakdown?: boolean;
  /** @format int32 */
  hundred?: number | null;
  /** @format int32 */
  one?: number | null;
  /** @format int32 */
  ten?: number | null;
  /** @format int32 */
  total_amount_of_bills?: number | null;
  /** @format int32 */
  total_worth_of_bills?: number | null;
  /** @format int32 */
  transaction_count?: number | null;
  /** @format int32 */
  twenty?: number | null;
  /** @format int32 */
  two?: number | null;
}

export interface UpdateAtmIntegrationRequest {
  /** The client friendly name. */
  friendly_name?: string | null;
  /** The array of products to associate with a freshly created ATM. */
  products?: ProductType[] | null;
}

export interface UpdateAtmRequest {
  /** Flag to indicate if the Bankline Post Provisioning is enabled on the ATM. */
  bankline_post_provision?: boolean;
  /** Physical lock identifier */
  lock_serial_number?: string | null;
  /** Description of lock combination/key */
  lock_set_to?: string | null;
  /** Modem hardware identifier */
  modem_serial?: string | null;
  /** Name of the ATM. */
  name?: string | null;
  /**
   * Node ID of the ATM's.
   * @format int32
   */
  node_id?: number | null;
  /** Operator ID associated with the ATM. */
  operator_id?: string | null;
  /** Padlock presence/type */
  padlock?: string | null;
  qaid?: string | null;
}

export interface UpdateBillNoteRequest {
  /** @minLength 1 */
  display_name: string;
  is_active?: boolean;
  metadata?: Record<string, any>;
  variant?: string | null;
}

export interface UpdateBoxClearRequest {
  /** @format date-time */
  created_at?: string | null;
  reason?: string | null;
  status?: BoxClearStatus;
}

export interface UpdateCaseRequest {
  assigned_user_id?: string | null;
  description?: string | null;
  issue_ids?: string[] | null;
  merchant_id?: string | null;
  priority?: CasePriority;
  resolution_summary?: string | null;
  status?: CaseStatus;
  type?: CaseType;
}

export interface UpdateCashServiceRequest {
  description?: string | null;
  is_active?: boolean | null;
  name?: string | null;
}

export interface UpdateCashVaultBranchRequest {
  description?: string | null;
  is_active?: boolean | null;
  name?: string | null;
}

export interface UpdateNoteDispenserRequest {
  cassetes?: CassetteUpdate[] | null;
  /** @format int32 */
  cassette_slot_count?: number | null;
}

export interface UpdateOperatorAtmRequest {
  /** Physical lock identifier */
  lock_serial_number?: string | null;
  /** Description of lock combination/key */
  lock_set_to?: string | null;
  /** Modem hardware identifier */
  modem_serial?: string | null;
  /**
   * Name of the ATM.
   * @minLength 1
   */
  name: string;
  /** Padlock presence/type */
  padlock?: string | null;
  /** Pick Up Id of the ATM. */
  pick_up_id?: string | null;
}

export interface UpdateOpsServiceRequest {
  description?: string | null;
  is_active?: boolean | null;
  name?: string | null;
}

export interface UpdateRestockRequest {
  adjustment_reason?: string | null;
  /** @format int32 */
  atm_id?: number;
  cassettes?: CreateRestockRequestItem[] | null;
  decommissioned_cassettes?: DecommissionCassetteRequestItem[] | null;
  loaded_bag_id?: string | null;
  notes?: string | null;
  restock_type?: RestockRequestType;
  status?: RestockRequestStatus;
}

export interface UpdateRouteRequest {
  name?: string | null;
  notes?: string | null;
  route_status?: RouteStatus;
  /** @format date-time */
  scheduled_at?: string | null;
  /** @format int32 */
  technician_id?: number | null;
}

export interface UpdateServiceTicketRequest {
  case_id?: string | null;
  details?: string | null;
  /** @format date-time */
  finish_date?: string | null;
  ops_service_id?: string | null;
  priority?: ServiceTicketPriority;
  service_window?: string | null;
  /** @format date-time */
  start_date?: string | null;
  status?: ServiceTicketStatus;
  /** @format int32 */
  technician_id?: number | null;
}

export interface UpdateServiceTicketTaskRequest {
  description?: string | null;
  /** @format int32 */
  sort_order?: number | null;
  task_type_id?: string | null;
}

export interface UpdateTaskResolutionReasonRequest {
  description?: string | null;
  is_active?: boolean | null;
  is_success_reason?: boolean | null;
  name?: string | null;
}

export interface UpdateTaskTypeRequest {
  description?: string | null;
  is_active?: boolean | null;
  name?: string | null;
}
